<div class="app-bg scroll-fix">

    <div class="container container-padding">

        <h1 class="page-header">{{ 'OFFER.HEADER' | translate: {number: offer.number} }}</h1>


        <app-alert alertType="info" *ngIf="flag?.active === false">
            {{ 'SCHEDULE.APPLICATION_IS_NOT_ACTIVE' | translate }}
        </app-alert>

        <div class="separator"></div>

        <div class="row" *ngIf="isActiveSales">
            <div class="col">
                <app-alert alertType="info">
                    <div>{{ 'OFFER.INFO_BOX' | translate }}</div>
                    <div>{{ 'OFFER.INFO_BOX_2' | translate }}</div>
                </app-alert>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <app-output [label]="'CONTRACT_DATE_PLACE' | translate">
                    {{ offer.statusDate | lsnDate }}, {{ offer.additionalData.location }}
                </app-output>
            </div>
        </div>

        <app-clients-summary-box [document]="offer"
                                 [readonly]="true">
        </app-clients-summary-box>

        <div class="separator"></div>

        <app-property-summary-box [document]="offer"
                                  [fullInsuranceDate]="false"
                                  [type]="summaryType.OFFER"
                                  [readonly]="true">
        </app-property-summary-box>

        <div class="separator"></div>

        <app-motor-summary-box [document]="offer"
                               [fullInsuranceDate]="false"
                               [type]="summaryType.OFFER"
                               [readonly]="true">
        </app-motor-summary-box>

        <div class="separator"></div>

        <div class="box" *ngIf="offer.premium !== null">
            <div class="box-body">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-size">
                        <div class="text-price">
                            <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                            <div class="item-price">{{ offer.premium | premium }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clauses [offer]="offer"
                     [readonly]="true">
        </app-clauses>


        <ng-container *ngIf="!readonly">
            <hr class="dimmed mt-5">

            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <button (click)="calculation()"
                            *ngIf="isActiveSales"
                            class="btn btn-link">
                        {{ 'OFFER.BACK_TO_CALCULATION' | translate }}
                    </button>


                    <button (click)="iOffer()"
                            *ngIf="canIOffer"
                            class="btn btn-secondary">
                        {{ 'BUTTON.SEND_OFFER' | translate }}
                    </button>

                    <button (click)="policy()"
                            *ngIf="isActiveSales"
                            class="btn btn-primary">
                        {{ 'OFFER.ACCEPT_OFFER' | translate }}
                    </button>
                </div>
            </div>
        </ng-container>

    </div>

</div>
